import React, { Component } from 'react';
import { Link } from 'react-router';
import UploadPhotoButton from './Elements/UploadPhotoButton';
import { config } from '../config';
import Button from 'material-ui/Button';
import ThumbUpIcon from 'material-ui-icons/ThumbUp';
import ThumbDownIcon from 'material-ui-icons/ThumbDown';
import Grid from 'material-ui/Grid';
import { db } from '../ThirdPartyIntegration/firebaseClient'

class Profile extends Component {
    constructor() {
        super();

        let userJsonString = window.localStorage.getItem(config.localstorage.userKey);
        let user = JSON.parse(userJsonString);

        this.state = {
            user: user,
            positiveRatings: 0,
            negativeRatings: 0
        };
    }

    componentDidMount() {
        db.ref(`/users/${this.state.user.uid}/receivedRatings`)
            .once('value')
            .then((snapshot) => {
                let receivedRatings = snapshot.val();
                if (receivedRatings) {
                    let positiveRatings = 0;
                    let negativeRatings = 0;

                    for (var key in receivedRatings) {
                        if (receivedRatings.hasOwnProperty(key)) {
                            let rating = receivedRatings[key];
                            if (rating.rating === 1) {
                                positiveRatings++;
                            } else {
                                negativeRatings++;
                            }
                        }
                    }

                    this.setState({
                        positiveRatings: positiveRatings,
                        negativeRatings: negativeRatings
                    })
                }
            })
    }

    render() {
        let pictureUrl = "https://placeimg.com/640/480/people";
        if (this.state.user.picture) {
            pictureUrl = this.state.user.picture;
        }

        const centerStyle = {
            textAlign: 'center'
        }

        const buttonSpaceStyle = {
            marginLeft: '5px',
            textDecoration: 'none'
        }

        return (
            <Grid container spacing={24}>
                <Grid item xs={12} style={centerStyle}>
                    <img src={pictureUrl} alt="me" />
                </Grid>
                <Grid item xs={12}>
                    <Grid container>
                        <Grid item xs={6} style={{ textAlign: 'right' }}>
                            <UploadPhotoButton whenDoneRedirectTo='/loggedin/edit-photo' />
                        </Grid>
                        <Grid item xs={6} style={{ textAlign: 'left' }}>
                            <Link style={buttonSpaceStyle} to="/loggedin/edit-photo">
                                <Button color="accent">Edit picture</Button>
                            </Link>
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item xs={12}>
                    <Grid container>
                        <Grid item xs={6} style={{ textAlign: 'right' }}>
                            <ThumbUpIcon /> {this.state.positiveRatings}
                        </Grid>
                        <Grid item xs={6} style={{ textAlign: 'left' }}>
                            <ThumbDownIcon /> {this.state.negativeRatings}
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        )
    }
}

export default Profile;


// WEBPACK FOOTER //
// ./src/Components/Profile.jsx